import Header from '../src/components/Header/Header';
import ControlPanel from '../src/components/ControlPanel/ControlPanel';
import MainPage from '../src/pages-components/MainPage/MainPage';
import Footer from '../src/components/Footer/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <MainPage />
      <Footer />
      <ControlPanel />
    </>
  );
}